import React from 'react';
import { Encounter } from './utils';
import { infoIcon, infoIcon2 } from '../components/common/Icons';
import moment from 'moment';

interface MedicalRecordsVisitHeaderProps {
    selectedEncounter?: Encounter;
}

const getPrettierkey = (key: string): string => {
    if (key.split('_').length > 1) {
        const words = key.split('_');
        words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
        return words.join(' ');
    }
    return key.charAt(0).toUpperCase() + key.slice(1);
};

const getValue = (value: any, key: string): string => {
    console.log('getValue', value, key);
    if (key === 'period_start' || key === 'period_end') {
        return moment(value * 1000).format('DD/MM/YY, hh:mm A');
    }
    return value.toString();
};

const IGNORE_KEYS = ['id', 'class', 'practitioner_name', 'practitioner_id'];

const MedicalRecordsVisitHeader: React.FC<MedicalRecordsVisitHeaderProps> = ({
    selectedEncounter,
}) => {
    if (!selectedEncounter) return null;
    const entries = Object.entries(selectedEncounter).filter(([key, value]) => !IGNORE_KEYS.includes(key));
    return (
        <div className="flex flex-row items-start justify-start gap-8 w-full">
            <div className="p-2">{infoIcon2('w-16 h-16')}</div>
            {entries.length > 0 && (
                <div className="flex pb-5 flex-row w-full items-center justify-start gap-8 flex-wrap">
                    {entries.map(([key, value], index) => (
                        <div className="flex flex-row items-center gap-4" key={index}>
                            <span
                                className="text-13 text-darwin-neutral-1 flex flex-row items-center gap-4"
                                key={index}
                            >
                                <span className="whitespace-nowrap font-600">
                                    {getPrettierkey(key)}:
                                </span>
                                <span className="whitespace-nowrap font-400">
                                    {getValue(value, key)}
                                </span>
                            </span>
                            {index < entries.length - 1 ? (
                                <div className="w-4 h-4 bg-neutral-2 rounded-full" />
                            ) : null}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MedicalRecordsVisitHeader;
